import { render, staticRenderFns } from "./PaymentsAssign.vue?vue&type=template&id=0ba06752&scoped=true"
import script from "./PaymentsAssign.vue?vue&type=script&lang=js"
export * from "./PaymentsAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba06752",
  null
  
)

export default component.exports